import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchTenantCommercialRules, saveTenantCommercialRules } from './api.js'

const QUERY_KEY = ['tenant-commercial-rules'] as const

export function useTenantCommercialRules() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: fetchTenantCommercialRules })
}

/**
 * `PUT` always replaces all four fields at once — there is no partial-patch
 * shape on the wire (`REQ-platform-core-the-commercial-rules-shape-for-
 * console`'s own note). `setQueryData` with the response rather than
 * invalidating: the server echoes what it actually persisted, read back from
 * the database, so it is authoritative — a refetch would just ask again for
 * the same answer.
 */
export function useSaveTenantCommercialRules() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveTenantCommercialRules,
    onSuccess: (rules) => {
      queryClient.setQueryData(QUERY_KEY, rules)
    },
  })
}
